module.exports = __webpack_public_path__ + "img/icon-ul-a.beefcc96.svg";